import { handleActions } from "redux-actions";
import { ALLOCATION_DIMENSION } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    ListAllocationDimensionRequestAction,
    ListAllocationDimensionCompleteAction,
    GetAllocationDimensionRequestAction,
    GetAllocationDimensionCompleteAction,
    CreateAllocationDimensionRequestAction,
    CreateAllocationDimensionCompleteAction,
    UpdateAllocationDimensionRequestAction,
    UpdateAllocationDimensionCompleteAction,
} from "actions/allocation-dimension";
import { IAllocationDimension } from "helpers/allocation-dimension";

export interface IListState extends IQuery<IAllocationDimension[]> {}
interface ISingleState extends IQuery<IAllocationDimension>, IMutate<IAllocationDimension> {
    isNew?: boolean;
}

export interface IState {
    list: IListState;
    single: ISingleState;
}

const initialState: IState = {
    list: {
        queryError: undefined,
        queryStatus: RequestStatus.Idle,
        result: [],
    },
    single: {
        queryError: undefined,
        queryStatus: RequestStatus.Active,
        mutateStatus: RequestStatus.Idle,
        mutateError: undefined,
        result: undefined,
        isNew: undefined,
    },
};

export const merchantAllocationDimension = handleActions<IState, any>(
    {
        [ALLOCATION_DIMENSION.LIST.REQUEST]: (state: IState, _action: ListAllocationDimensionRequestAction): IState => {
            return {
                ...state,
                list: {
                    ...initialState.list,
                    queryStatus: RequestStatus.Active,
                },
            };
        },
        [ALLOCATION_DIMENSION.LIST.COMPLETE]: (
            state: IState,
            action: ListAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    queryError: action.payload instanceof Error ? action.payload : undefined,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [ALLOCATION_DIMENSION.GET.REQUEST]: (state: IState, _action: GetAllocationDimensionRequestAction): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                },
            };
        },
        [ALLOCATION_DIMENSION.GET.COMPLETE]: (state: IState, action: GetAllocationDimensionCompleteAction): IState => {
            return {
                ...state,
                single: {
                    ...state.single,
                    queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    queryError: action.payload instanceof Error ? action.payload : undefined,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [ALLOCATION_DIMENSION.CREATE.REQUEST]: (
            state: IState,
            _action: CreateAllocationDimensionRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [ALLOCATION_DIMENSION.CREATE.COMPLETE]: (
            state: IState,
            action: CreateAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    result: action.payload instanceof Error ? undefined : action.payload,
                    isNew: true,
                },
            };
        },
        [ALLOCATION_DIMENSION.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdateAllocationDimensionRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [ALLOCATION_DIMENSION.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [ALLOCATION_DIMENSION.VALUES.CREATE.COMPLETE]: (
            state: IState,
            action: UpdateAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [ALLOCATION_DIMENSION.VALUES.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdateAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [ALLOCATION_DIMENSION.VALUES.SORT.COMPLETE]: (
            state: IState,
            action: UpdateAllocationDimensionCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
    } as any,
    initialState
);
